import { useState } from 'react'
import { handOverOpening, openProjectTab } from '../openProject'

/**
 * The prompt box on the overview page.
 *
 * Nothing is connected to a model yet. Sending opens a new project and carries
 * the typed line across as its first message, so the intended flow — say what
 * you want, get a project — is legible before the model is wired up.
 */
export function ChatLauncher() {
  const [value, setValue] = useState('')

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    const prompt = value.trim()
    if (!prompt) return
    // In a tab of its own; this page stays as it was, box emptied.
    openProjectTab(`/projects/new?opening=${handOverOpening(prompt)}`)
    setValue('')
  }

  return (
    <div className="chat-launcher">
      <span className="chat-launcher__mark" aria-hidden="true">
        <img className="chat-launcher__ring" src="/brand/logo-ring.svg" alt="" />
        <img className="chat-launcher__w" src="/brand/logo-mark.svg" alt="" />
      </span>

      {/* The shell carries the shadow: a filter on the masked box itself would
          be cut away by the mask, so it has to sit one level up. */}
      <div className="chat-launcher__shell">
        <form className="chat-launcher__box" onSubmit={handleSubmit}>
          <label className="chat-launcher__label" htmlFor="overview-prompt">
            Describe what you want to make
          </label>
          <input
            id="overview-prompt"
            className="chat-launcher__input"
            value={value}
            onChange={(event) => setValue(event.target.value)}
            placeholder="Don't know how to start? Chat with me!"
            autoComplete="off"
          />
          <button
            type="submit"
            className="chat-launcher__send"
            disabled={value.trim().length === 0}
            aria-label="Start a project"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M8 13V3M8 3 3.5 7.5M8 3l4.5 4.5"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </form>
      </div>
    </div>
  )
}
